import { type Filter, FilterType } from '../types/filters';

/**
 * Converts a static list filter with boolean string values ('true'/'false') to a boolean.
 * Only used for filters like EXTERNALLY_OWNED and PUBLIC which have 'true'/'false' as selection IDs.
 * @param filter - StaticListFilter with selections containing 'true' or 'false' string IDs
 * @param id - The key name for the returned object (e.g., 'is_public', 'is_subsidiary')
 * @returns Object with the boolean value, or empty object if no selection
 */
export const getStaticListBoolean = (filter: Filter, id: string) => {
  if (filter.type !== FilterType.STATIC_LIST) {
    return {};
  }

  const { selections } = filter;

  if (!selections || selections.length === 0) {
    return {};
  }

  const selectionId = selections[0]?.id;
  const booleanValue = selectionId === 'true';

  return {
    [id]: booleanValue,
  };
};
